import {
  AlternativeToggleRadioGroup,
  Content,
  Flex,
  FormInput,
  fromTheme,
  usePlatformInfo,
} from '@acsbe/ui';
import { Dispatch, SetStateAction } from 'react';
import { styled } from 'styled-components';
import { useDomainSelection } from '../../../context/DomainSelectionContext';
import { useAnalytics } from '../../../services/analytics';
import { BUTTON_CLICKED } from '../../../services/analytics/event-names';
import { BillingCycle as Billing } from './Plan';
import { LicenseDetails } from './types';
import { VisitReportBanner } from './visit-report-banner';

interface BillingCycleProps {
  billingCycle: Billing;
  setBillingCycle: Dispatch<SetStateAction<Billing>>;
  license?: LicenseDetails;
  annualDiscountText: string;
}

export const BillingCycle = (props: BillingCycleProps) => {
  const analytics = useAnalytics();
  const onBillingTypeChange = (value: Billing | string) => {
    switch (value) {
      case 'annually':
      case 'monthly':
        props.setBillingCycle(value);
        break;
      default:
        console.error('Invalid billing cycle', value);
    }
    analytics.mixpanel.trackEvent(BUTTON_CLICKED, {
      buttonName: value,
      buttonTag: value + '-billing',
    });
  };

  const { isMobile, uptoTablet } = usePlatformInfo();
  const { paymentOverlayMessage, licenseDetails } = useDomainSelection();

  return (
    <Flex
      align="flex-start"
      gap={6}
      self="stretch"
      style={{ opacity: paymentOverlayMessage ? '.1' : '1' }}
    >
      <Flex row={!uptoTablet} align="flex-start" gap={6} self="stretch">
        <Flex align="flex-start" gap={3} stretch>
          <VisitReportBanner />
        </Flex>
        {!licenseDetails?.customPrice && (
          <Flex
            align={uptoTablet ? 'center' : 'flex-end'}
            gap={3}
            justify="center"
            self="stretch"
            stretch
          >
            <Flex position="relative">
              <AlternativeToggleRadioGroup
                label="billing"
                name="billing"
                //@ts-ignore
                value={props.billingCycle}
                onChange={onBillingTypeChange}
              >
                <FormInput
                  type="radio"
                  value="annually"
                  label={`Yearly ${props.annualDiscountText ? '(' + props.annualDiscountText + ')' : ''}`}
                  aria-describedby="twenty-percent"
                />
                <FormInput type="radio" value="monthly" label="Monthly" />
              </AlternativeToggleRadioGroup>
            </Flex>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

const StyledContent = styled(Content)`
  font-size: 22px;
  font-weight: 600;

  @media ${fromTheme('viewport.uptoMobile')} {
    font-size: 18px;
  }
`;

const StyledSpan = styled.span`
  font-weight: 700;
  line-height: 125%;
`;
